import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { CurrencyValue, InfoTooltip } from "components/support";

import style from "./style";

class Chart extends Component {
  render() {
    const { className, totalRevenues } = this.props;
    const revenue = typeof totalRevenues === "number" ? totalRevenues : 0;
    return (
      <Paper elevation={1} className={`${className} pv-sm full-height`}>
        <Row middle="xs" center="xs" className="full-height">
          <Col xs={12}>
              <Typography
                type="display2"
                className="pb-sm revenues-title"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                Faturamento Total
                <InfoTooltip hint="Inclui faturamento dos opcionais." />
              </Typography>
            <Typography type="display2" className="total-revenues">
              <CurrencyValue value={revenue} type="money" />
            </Typography>
          </Col>
        </Row>
      </Paper>
    );
  }
}

export default style(Chart);



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/revenues/index.js